import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import { MobileDeviceWidth } from '../lib/constants'
import CloseButton from '../components/close-button'
import TextButton from '../components/text-button'

const StyledOverlay = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  max-height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  opacity: 0.5;
  z-index: 102;
`

const StyledContainer = styled.div`
  position: fixed;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 50%;
  min-width: 200px;
  max-width: 90%;
  max-height: 90%;
  background-color: ${colours.white};
  z-index: 102;
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  font-weight: 100;
  @media (max-width: ${MobileDeviceWidth}px) {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
  }
`

const StyledHeadingContainer = styled.div`
  text-align: left;
  padding: 20px 20px 15px 40px;
  display: flex;
  color: ${colours.darkPurple};
  background-color: ${colours.lightGray};
  align-items: baseline;
`

const StyledHeading = styled.h1`
  font-weight: 200;
  font-size: 20px;
  color: ${colours.darkPurple};
  line-height: 37px;
  margin: 0;
  text-transform: uppercase;
`

const StyledContentContainer = styled.div`
  text-align: left;
  padding: 20px 40px;
  color: ${colours.darkPurple};
  overflow: auto;
`

const StyledFooterContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  padding: 15px 20px 15px 40px;
  color: ${colours.darkPurple};
`

interface IProps {
  open: boolean
  setPopupState?: any
  modal?: boolean
  showHeader?: boolean
  showFooter?: boolean
  heading?: string
  children: any
  additionalButtons?: any[]
}

class Dialog extends React.Component<IProps> {
  static defaultProps: { modal: boolean; showHeader: boolean; showFooter: boolean; setPopupState: () => void }

  render() {
    const { open, setPopupState, modal, showHeader, showFooter, heading, children, additionalButtons } = this.props
    return (
      <>
        {modal && (
          <StyledOverlay
            onClick={() => setPopupState(false)}
            style={{
              visibility: open ? 'visible' : 'hidden'
            }}
          ></StyledOverlay>
        )}
        <StyledContainer
          onClick={e => {
            e.stopPropagation()
          }}
          style={{
            visibility: open ? 'visible' : 'hidden'
          }}
        >
          {showHeader && (
            <StyledHeadingContainer>
              <StyledHeading>{heading}</StyledHeading>
              <CloseButton onClick={() => setPopupState(false)} />
            </StyledHeadingContainer>
          )}
          <StyledContentContainer>{children}</StyledContentContainer>
          {showFooter && (
            <StyledFooterContainer>
              <TextButton onClick={() => setPopupState(false)}>Close</TextButton>
              {additionalButtons
                ? additionalButtons.map((additionalButton: any) => {
                    return (
                      <TextButton
                        key={`textButton${additionalButton.text}`}
                        primary={additionalButton.primary}
                        onClick={additionalButton.onClickHandler}
                        disabled={additionalButton.disabled}
                      >
                        {additionalButton.text}
                      </TextButton>
                    )
                  })
                : null}
            </StyledFooterContainer>
          )}
        </StyledContainer>
      </>
    )
  }
}

Dialog.defaultProps = {
  modal: true,
  showHeader: true,
  showFooter: true,
  setPopupState: () => {}
}

export default Dialog
